/**
 * Convert cmsConfig we get from graphql into object
 * Some fields are json as a string, this method converts them to an object
 * @param {*} field
 */
function parseAppConfigProperties(field) {
	if (Array.isArray(field)) {
		field.forEach(f => {
			parseAppConfigProperties(f)
		})
	} else if (typeof field === "object") {
		for (const key in field) {
			if (key.includes("JsonString")) {
				field[key] = JSON.parse(field[key])
			} else {
				parseAppConfigProperties(field[key])
			}
		}
	}

	return field
}

/**
 * Convert cmsConfig object into API input object
 * Some fields are json as a string, this method converts object to objects as a string
 * @param {*} field
 */
function stringifyAppConfigProperties(field) {
	if (Array.isArray(field)) {
		field.forEach(f => {
			stringifyAppConfigProperties(f)
		})
	} else if (typeof field === "object") {
		for (const key in field) {
			if (key.includes("JsonString")) {
				field[key] = field[key] ? JSON.stringify(field[key]) : null // if there is null, prevent having "null" as a string
			} else {
				stringifyAppConfigProperties(field[key])
			}
		}
	}

	return field
}

export { parseAppConfigProperties, stringifyAppConfigProperties }
